import { put, call} from 'redux-saga/effects';
import { ActiveUser } from '../../app/components/AdminCenter/views/Helper/activeUserHelper';
import * as actionTypes from './actionTypes';

export function* addUserInSaga(payload){
    try {
        const response = yield call(ActiveUser, payload.user);
        yield put({type: actionTypes.ADD_IN_USER_SUCCESS, response});
    } catch (error) {
        yield put({type: actionTypes.ADD_IN_USER_ERROR, error});
    }
}